import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AnalisarReprogramacaoService = {
  async getById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/reprogramacao/ferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async aprovarAlteracao(id) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/reprogramacao/aprovar/${id}`);
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule(await response.message, "success");
    return true;
  },

  async recusarAlteracao(id, postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/reprogramacao/recusar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule("Recusado com sucesso", "success");
    return true;
  },
}